import { Box, Paper, CircularProgress, Typography, Button } from "@mui/material";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate, useLocation } from "react-router-dom";


import { microsoftCallback, logout } from "../../actions/auth.js";

// function useQuery() {
//     const { search } = useLocation(); 
//     let q = {};
//     search.split(/\?|&/).forEach(p => {
//         let [key, value] = p.split("=");
//         if(key) q[key] = value;
//     });
//     return q;
// }

export default function OutlookCallback() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { search } = useLocation(); 
    const { isLoggedIn, err } = useSelector((state) => state.user);

    useEffect(() => {
        if(search.startsWith('?code='))
        dispatch(microsoftCallback(search));
    }, [])

    return (
        isLoggedIn ? <Navigate to="/profile" replace="true" /> :
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100vw"
                height="100vh"
                className="bg-[linear-gradient(30deg,rgba(0,206,244,1)_35%,rgba(0,164,255,1)_100%)]"
            >
                {
                    Boolean(err) ? <Paper className="!p-4" elevation={7}>
                        <Typography>{err}</Typography>
                        <br />
                        <Box textAlign='center'>
                            <Button variant="contained" color="secondary" onClick={() => { 
                                dispatch(logout());
                                navigate("/login", { replace: true })  
                            }}>Back To Login</Button>
                        </Box>
                    </Paper> :
                    <CircularProgress />
                }
            </Box>
    );
}
